export const planCatalogPricingNoticeStyles = {
  container: {
    width: '100%',
    padding: '12px 14px',
    borderRadius: '8px',
    backgroundColor: '#FFF8E6',
    border: '1px solid #F5D565',
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 13,
    lineHeight: '18px',
    color: '#7A5C00',
    marginBottom: '4px',
  },
  text: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '18px',
    color: '#7A5C00',
  },
};
